<template>
    <div>
        <ModalHeader title="주소 검색"></ModalHeader>
        <div style="flex:1;">
            <div ref="daumAddress" style="width:100%; height:100%;"></div>
        </div>
    </div>
</template>

<script>
    import ModalHeader from "../common/ModalHeader";
    export default {
        name: "DaumAddress",
        props : {
            completeAction : {
                type : Function,
                default : () =>{}
            }
        },
        components: {ModalHeader},
        methods : {
            setDaum(){
                const daumAddress = this.$refs.daumAddress;
                new window.daum.Postcode({
                    oncomplete: (data) => {
                        // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                        var addr = ''; // 주소 변수

                        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                            addr = data.roadAddress;
                        } else { // 사용자가 지번 주소를 선택했을 경우(J)
                            addr = data.jibunAddress;
                        }

                        this.completeAction(data.zonecode, addr);
                        this.$GlobalStore.closeLastModal();
                    },
                    width : '100%',
                    height : '100%'
                }).embed(daumAddress);
            }
        },
        created(){
            const daum = document.createElement('script');
            daum.addEventListener("load", () => {
                this.setDaum();
            });

            daum.setAttribute('src', "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js");
            document.head.appendChild(daum);
        }
    }
</script>

<style scoped>

</style>